export default function isDateAllowed(date, min, max, allowedFn) {
  return (!allowedFn || allowedFn(date)) && (!min || date >= min.substr(0, 10)) && (!max || date <= max);
}
//# sourceMappingURL=isDateAllowed.js.map


// WEBPACK FOOTER //
// ./node_modules/vuetify/lib/components/VDatePicker/util/isDateAllowed.js